/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ContentGenerateBody model module.
 * @module model/ContentGenerateBody
 * @version 1.0.0
 */
export class ContentGenerateBody {
  /**
   * Constructs a new <code>ContentGenerateBody</code>.
   * @alias module:model/ContentGenerateBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ContentGenerateBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ContentGenerateBody} obj Optional instance to populate.
   * @return {module:model/ContentGenerateBody} The populated <code>ContentGenerateBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ContentGenerateBody();
      if (data.hasOwnProperty('dataAutomationId'))
        obj.dataAutomationId = ApiClient.convertToType(data['dataAutomationId'], 'String');
      if (data.hasOwnProperty('scriptParamsJSON'))
        obj.scriptParamsJSON = ApiClient.convertToType(data['scriptParamsJSON'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} dataAutomationId
 */
ContentGenerateBody.prototype.dataAutomationId = undefined;

/**
 * @member {String} scriptParamsJSON
 */
ContentGenerateBody.prototype.scriptParamsJSON = undefined;

